import axios from 'axios';

/**
 * Get the current Google connection status
 * @returns {Promise<Object>} Connection status and integration details
 */
export const getGoogleConnectionStatus = async () => {
  try {
    const response = await axios.get('/google-contacts/status');
    return response.data;
  } catch (error) {
    console.error('Failed to get Google connection status:', error);
    throw error;
  }
};

/**
 * Initiate Google OAuth flow
 * @returns {Promise<string>} Google OAuth URL
 */
export const initiateGoogleAuth = async () => {
  try {
    const response = await axios.get('/google-contacts/auth');
    return response.data.auth_url;
  } catch (error) {
    console.error('Failed to initiate Google auth:', error);
    throw error;
  }
};

/**
 * Fetch Google contacts with matching status
 * @returns {Promise<Object>} Google contacts with match status
 */
export const fetchGoogleContacts = async () => {
  try {
    const response = await axios.get('/google-contacts/list');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Google contacts:', error);
    throw error;
  }
};

/**
 * Sync selected Google contacts
 * @param {Array<string>} contactIds - Array of Google contact IDs to sync
 * @returns {Promise<Object>} Sync results
 */
export const syncSelectedContacts = async (contactIds) => {
  try {
    const response = await axios.post('/google-contacts/sync', {
      contact_ids: contactIds,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to sync Google contacts:', error);
    throw error;
  }
};

/**
 * Disconnect Google account
 * @returns {Promise<Object>} Disconnect result
 */
export const disconnectGoogle = async () => {
  try {
    const response = await axios.delete('/google-contacts/disconnect');
    return response.data;
  } catch (error) {
    console.error('Failed to disconnect Google account:', error);
    throw error;
  }
};

/**
 * Handle Google OAuth callback
 * @param {string} code - Authorization code from Google
 * @param {string} state - State parameter for CSRF protection
 * @returns {Promise<Object>} Callback result
 */
export const handleGoogleCallback = async (code, state) => {
  try {
    const response = await axios.get('/google-contacts/callback', {
      params: { code, state },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to handle Google callback:', error);
    throw error;
  }
};
